import { ApiModelProperty } from '@nestjs/swagger/dist/decorators/api-model-property.decorator';
import { KYCStatus } from '../../../transact-api';
import { AccreditationCheckStatus } from '../models/accreditation-status.enum';
import { IsString } from 'class-validator';

export class AccountAccreditationDto {
    @ApiModelProperty({
        type: () => 'string',
        description: 'Nc account id of the investor account',
    })
    @IsString()
    ncAccountId: string;
    
    @ApiModelProperty({
        type: 'string',
        enum: Object.values(AccreditationCheckStatus),
    })
    status: AccreditationCheckStatus;

    @ApiModelProperty({
        type: 'string',
        isArray: true,
        description: 'list of files uploaded by the investor',
    })
    files: Array<string>;

    @ApiModelProperty()
    uploadDate: Date;

    @ApiModelProperty({
        type: () => 'string',
        description: 'Note provided by the user when submitting the document',
        nullable: true,
    })
    note?: string;

    @ApiModelProperty({
        type: () => 'string',
        description: 'the message put by the client for the investor when updating the accreditation status',
        nullable: true,
    })
    statusMessage?: string;
}

